import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { AuthModule } from "../store/auth";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/CheckInForm",
    name: "CheckInForms",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/CheckInForm.vue"),
  },
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/EventInfo",
    redirect: "/QRScanner"
  },
  {
    path: "/Expired",
    name: "ExpiredLink",
    component: () =>
      import(/* webpackChunkName: "expired" */ "../views/ExpiredLink.vue"),
  },

  {
    path: "/QRScanner",
    name: "QRScanner",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "qrscanner" */ "../views/QRScanner.vue"),
  },
  {
    path: "/:meetingID/:meetingCode",
    name: "AutoLogin",
    component: () =>
      import(/* webpackChunkName: "opens" */ "../views/AutoLogin.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const currentToken = AuthModule.currentEventToken;
  // if u need to be logged in then check token
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (currentToken === null) {
      next("/");
    } else {
      next();
    }
  }

  next();
});

export default router;
